import { allFeaturesAtFalse } from './default';
import souffletLogoUrl from '@b2ag/themes/farmi/logo/soufflet-white-transparent.png';
export const features = {
    ...allFeaturesAtFalse,
    home: {
        ...allFeaturesAtFalse.home,
        advantages: true,
        anchors: [
            {
                label: 'Top catégories',
                selector: '#home-categories',
                hideLink: false,
            },
            {
                label: 'Nos marques',
                selector: '#home-brands',
                hideLink: true,
            },
            {
                label: 'Rejoindre aladin.farm',
                selector: '#home-why-aladin',
                hideLink: true,
            },
            {
                label: 'Produits',
                selector: '.recommended-products',
                hideLink: true,
            },
        ],
    },
    certificates: {
        phyto: true,
        explosive: true,
    },
    contact: {
        mailTo: 'contact@farmi.com',
    },
    shoppingList: true,
    header: {
        leftEntries: [
            {
                name: 'Accueil',
                path: '/',
            },
            {
                name: 'Appro',
                path: '/shop',
            },
            {
                name: 'Collecte',
                path: '/collect',
            },
            {
                name: 'Agro Pilot',
                path: '/agro-pilot',
            },
        ],
    },
    footer: {
        sponsor: {
            config: {
                logo: souffletLogoUrl,
                altText: 'logo Soufflet',
                homePageUrl: 'https://www.invivo-group.com/fr/activites/agriculture/soufflet-agriculture',
            },
        },
        social: {
            facebook: 'https://www.facebook.com/people/Farmi/100069885982525/',
            linkedin: 'https://www.linkedin.com/company/soufflet-agriculture',
            x: 'https://twitter.com/Soufflet_Agri',
            youtube: 'https://www.youtube.com/channel/UCdPjArAnZWLw1GYQxLxLuaQ',
        },
        apps: {
            iOS: 'https://apps.apple.com/fr/app/farmi/id1272774852',
            Android: 'https://play.google.com/store/apps/details?id=com.soufflet.farmi&hl=fr&gl=US&pli=1',
        },
        sitemap: [
            {
                title: 'Mieux nous connaître',
                links: [
                    {
                        label: 'À propos de Farmi',
                        internalTo: { name: 'about' },
                    },
                    {
                        label: 'Actualités agricoles',
                        internalTo: { name: 'annuaire' },
                        customClickEventFunction: 'trackGotToArticleBook',
                    },
                ],
            },
            {
                title: 'Nos services',
                links: [
                    {
                        label: 'Foire aux questions',
                        internalTo: { path: '/article/foire-aux-questions' },
                    },
                    {
                        label: 'Blog Farmi',
                        externalHref: 'https://www.terre-net.fr/farmi-vous-simplifie-lagri/t23745',
                    },
                    {
                        label: 'Accès espace client',
                        internalTo: { name: 'login' },
                    },
                ],
            },
            {
                title: "Besoin d'une information ?",
                links: [
                    {
                        label: 'Écophyto',
                        externalHref: 'https://agriculture.gouv.fr/ecophyto-reduire-et-ameliorer-lutilisation-des-phytos',
                    },
                    {
                        label: 'Nous contacter',
                        mailTo: 'contact@farmi.com',
                    },
                ],
            },
        ],
    },
    pdp: {
        templateB2AGFeature: true,
        showOnlyMainImage: true,
        showSupplier: false,
    },
    checkoutV2: {
        displayRpd: true,
        displayMention: true,
        selectionByProducts: true,
        blockAddressForPricerOffer: true,
    }
};
//# sourceMappingURL=farmi.js.map